export default __webpack_public_path__ + "static/media/card.29382235.svg";